import { SupabaseServiceView } from "../../../server/supabase/base-supabase-service";

export class SupabaseAnalyticsDataService extends SupabaseServiceView<"user_data"> {
  table = "user_data" as const;
}
